import './Skin.css';
import SkinPistol from '../../images/pistol.png';
import { Dispatch, SetStateAction, useState } from 'react';
import { array } from 'yup';
import { SkinType } from '../../utils/types';

interface SkinProps {
    arrChoiceSkin: SkinType[];
    setArrChoiceSkin: Dispatch<SetStateAction<SkinType[]>>;
    skin: SkinType;
}

export const Skin = ({ arrChoiceSkin, setArrChoiceSkin, skin }: SkinProps) => {
    const [isSelected, setIsSelected] = useState(false);

    const pushArr = (item: SkinType) => {
        if (!isSelected) {
            setArrChoiceSkin([...arrChoiceSkin, item]);
        } else {
            setArrChoiceSkin((value) => {
                return value.filter((itemData) => itemData.id !== item.id);
            });
        }
    };

    const toggleActive = () => {
        pushArr(skin);
        setIsSelected(!isSelected);
    };

    return (
        <div onClick={toggleActive} className={`${isSelected ? 'skin skin_selected' : 'skin'}`}>
            <img src={SkinPistol} alt="" className="skin__img" />
            <span className="skin__price">{skin.amount} р.</span>
            <div className="skin__background"></div>
        </div>
    );
};
